import { Link } from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import Logo from 'assets/images/logo.svg';
import Logo2 from 'assets/images/logo2.svg';

export const Header = () => {
	return (
		<header className='authorization'>
			<div className='authorization__container'>
				<div className='authorization__head'>
					<Link className='authorization__link' to={'/'}>
						<img src={Logo2} alt=''/>
					</Link>
					
					<Link className='authorization__link' to={'/'}>
						<img src={Logo} alt=''/>
					</Link>
				</div>
				<h1 className='authorization__title'>Долголетие для всех</h1>
				<p className='authorization__caption'>
					Всероссийский конкурс лучших практик <br/>
					работы с людьми старшего поколения
				</p>

				<div className='breadscrumb authorization__breadscrumb'>
					<Breadcrumbs />
				</div>
			</div>
		</header>
	);
};
